import React from "react";
import { Segment, Button, CloseIcon, Flex } from "@fluentui/react-northstar";

export interface FullScreenPanelProps {
    onClose: () => void;
    isOpen?: boolean;
}

export const FullScreenPanel: React.FC<FullScreenPanelProps> = (props) => (
    <Segment style={{ position: "fixed", top: 0, left: 0, height: "100vh", width: "100vw", zIndex: props.isOpen ? 1002 : -1, display: props.isOpen ? undefined : "none" }}>
        <div style={{ position: "fixed", top: 10, right: 10, zIndex: 1010 }}>
            <Button iconOnly={true} icon={<CloseIcon size="large" />} onClick={props.onClose} />
        </div>
        <Flex fill hAlign="center" vAlign="center">
            {props.children}
        </Flex>
    </Segment>
);
